
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.75 20.25a1.75 1.75 0 011.744 1.606L39.5 22v14.25a5.75 5.75 0 01-5.53 5.746l-.22.004h-19.5a5.75 5.75 0 01-5.746-5.53l-.004-.22V22a1.75 1.75 0 013.494-.144L12 22v14.25a2.25 2.25 0 002.096 2.245l.154.005h19.5a2.25 2.25 0 002.245-2.096L36 36.25V22c0-.966.784-1.75 1.75-1.75zM23.499 6.268l.149-.015.175-.002.154.013.178.033.069.018c.195.054.383.143.553.266l.12.095.093.087 7.778 7.778a1.75 1.75 0 01-2.35 2.588l-.125-.113-4.793-4.794V31.5a1.75 1.75 0 01-1.606 1.744l-.144.006a1.75 1.75 0 01-1.744-1.606L22 31.5V12.226l-4.788 4.79a1.75 1.75 0 01-2.35.113l-.125-.113a1.75 1.75 0 01-.114-2.35l.114-.125 7.752-7.754a1.76 1.76 0 01.179-.162l.113-.081c.038-.027.077-.05.118-.073l.019-.01c.177-.097.373-.163.58-.193z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    